<template>
    
    <div>
        <el-button type="primary" @click="addAdmin" class="addAdmin">添加菜单</el-button>
        <div class="down">
        <el-table
            :data="menuList"
            style="width: 100%;margin-bottom: 20px;"
            row-key="menuId"
             align='center'
            lazy
            :load="load"
            default-expand-all
            :tree-props="{children: 'chridens', hasChildren: 'hasChildren'}"

            ref="roles">
             <el-table-column
                type="index"
                 label="序号"
                min-width="200"  align='center'>
            </el-table-column>
            <el-table-column
            prop="menuId"
            label="ID"
            sortable
            min-width="180"  align='center'>
            </el-table-column>
            <el-table-column
            prop="menuPath"
            label="菜单路径"
            
            min-width="180"  align='center'>
            </el-table-column>
            <el-table-column
            prop="menuName"
            label="菜单名称" min-width='180' align='center'>
            </el-table-column>
             <el-table-column
            prop="isValide"
            label="是否有效" min-width='180' align='center'>
            <template slot-scope="scope">
                    <div>
                        {{scope.row.isValide == 1?'有效':'无效'}}
                   
                    </div>
                    
                </template>
            </el-table-column>
              <el-table-column
            prop="iconCls"
            label="小图标"   align='center' min-width='180'>
                <template slot-scope="scope">
                     <div>
                         <i style="color: #409eff;" :class="scope.row.iconCls"></i>
                     </div>
                </template>
            </el-table-column>
            <el-table-column
            prop="level"
            label="菜单级别" min-width='180'  align='center'>
                
            </el-table-column>
             <el-table-column
            prop="sortNum" sortable
            label="菜单权重" min-width='180' align='center'>
                 
            </el-table-column>
             <el-table-column
                prop="menuId"
                label="操作"
                min-width="280"  align='center'>
                 <template slot-scope="scope">
                    <div>
                        <el-button type="primary" @click="editRoles(scope.row)">编辑</el-button>
                       <el-button type="primary" @click="addAdmin(scope.row)" v-if="scope.row.level==1?true:scope.row.level==2?true:false">添加子菜单</el-button> 
                    </div>
                    
                </template>
                </el-table-column>
        </el-table>
           
           <!-- <ul class="infinite-list" style="overflow:auto">
                <li v-for="(obj,index) in runLog"  v-bind:key="index" class="infinite-list-item" >{{ obj.body }}</li>
            </ul>-->



<div class="block">
    
 
  </div>

        </div>
        <el-dialog
            :title="title"
            :visible.sync="centerDialogVisible"
            width="30%"
            center>
            <span>
                <el-form ref="form" :model="form" label-width="80px">
                <el-form-item label="菜单名称">
                    <el-input v-model="form.menuName"></el-input>
                </el-form-item>
                <el-form-item label="菜单路径">
                    <el-input v-model="form.menuPath"></el-input>
                </el-form-item>
                 <el-form-item label="菜单接口">
                    <el-input v-model="form.menuUrl"></el-input>
                </el-form-item>
                 <el-form-item label="菜单组成">
                    <el-input v-model="form.component"></el-input>
                </el-form-item>
                 <el-form-item label="菜单类">
                    <el-input v-model="form.menuClass"></el-input>
                </el-form-item>
                 <el-form-item label="小图标">
                    <el-input v-model="form.iconCls"></el-input>
                </el-form-item>
                 <el-form-item label="是否有效">
                    <el-radio-group v-model="form.isValide">
                    <el-radio :label="0" border>无效</el-radio>
                    <el-radio :label="1" border>有效</el-radio>
                    </el-radio-group>
                </el-form-item>
                 <el-form-item label="菜单权重">
                    <el-input v-model="form.sortNum"></el-input>
                </el-form-item>
              
                </el-form>

            </span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="centerDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="addAdminFunct">确 定</el-button>
            </span>
            </el-dialog>

    </div>

    
</template>
<script>
import {Message} from 'element-ui';
export default {
    
name:"version",
    data(){
        return {
            title:"权限列表",
            roles:[],
            menuList:[],
            roleId:0,
            menu:[],
            
            condition:true,
            dialogTitle:"",
            chridens:[],
            addMenu:[],
            addRoleMenu:{},
            centerDialogVisible: false,
            centerDialogVisibleimgSrc:false,
            centerDialogRoleVisible:false,
            form:{
                addTime: 0,
                isValide:1,
                iconCls:'',
                component: '',
                level: 1,
                menuClass: '',
                parentId:0,
                menuId: 0,
                menuName: '',
                menuPath: '',
                menuUrl: '',
         
                sortNum: 0
            },
            params:{},
            defaultProps: {
                children: 'chridens',
                label: 'menuName'
            },
            total:1,
            imgSrc:''
          
        }
    },
    methods:{
       clickBig(obj){
           this.imgSrc=obj;
           this.centerDialogVisibleimgSrc = true
       },
       editRoles(info){
           this.condition=false
           this.form.menuId=info.menuId
           this.form.isValide=info.isValide
           this.form.iconCls=info.iconCls
           this.form.parentId=info.parentId
           this.form.menuClass=info.menuClass
           this.form.menuName=info.menuName
           this.form.menuPath=info.menuPath
           this.form.menuUrl=info.menuUrl
           this.form.sortNum=info.sortNum
           this.form.level=info.level
           this.form.component=info.component
           this.centerDialogVisible = true
          
       },
     load(tree, treeNode, resolve){
         console.log("tree.menuId:"+tree.menuId)
        this.params.menuId = tree.menuId
         this.postRequest('/menu/page_list', this.params).then(resp => {
                this.loading = false;
                if (resp) {
                   resolve(resp.data)
                    this.chridens = resp.data
                }
            })
        // resolve(this.chridens)
        
     },
    
       addAdmin(info){
           this.centerDialogVisible = true
            this.form.parentId=info.menuId
           this.form.menuClass=''
           this.form.menuName=''
           this.isValide=1
           this.iconCls=''
           this.form.menuPath=''
           this.form.menuUrl=''
           this.form.sortNum=0
           this.form.level=0
           this.form.component=''
           this.title = '添加菜单';

       },
       addMenuFunct(){
           this.addMenu = [];
           var array = this.$refs.tree.getCheckedNodes();
           array.forEach(element => {
               this.addMenu.push(element.menuId)
           })
           this.addRoleMenu.roleId = this.roleId;
           this.addRoleMenu.menuIds = JSON.stringify(this.addMenu);
           this.postRequest('/role/bind_menu',this.addRoleMenu).then(resp => {
               if(resp){
                   this.centerDialogRoleVisible = false
                      Message.success({message: resp.msg})
               }
           })
           
       },
       addAdminFunct(){
           this.params.menuId = 0
           this.postRequest('/menu/add', this.form).then(resp => {
                if (resp) {
                    this.centerDialogVisible = false
                    this.loadAdminList()
                   // Message.success({message: resp.msg})
                }
            })
       },
       onSubmit() {
        console.log('submit!');
      },
       loadAdminList(){
           
             this.postRequest('/menu/page_list', this.params).then(resp => {
                this.loading = false;
                if (resp) {
                   
                    this.menuList = resp.data
                }
            })
       }     
    },
 mounted(){
     this.loadAdminList();
 }
}
</script>
<style>
    .block{
        margin-top: 1%;
        margin-right: 1%;
    }
    .infinite-list{
        border: rgba(92, 48, 145, 0.04);
        margin-top: 1%;
        margin-left: 10%;
    }
    .alal{
      background-image: url(../../assets/1231232.jpg);
        
    }
    .all{
       box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
    }
   
    .h1{
        font-style: initial;
        font-size: 50px;
    }
    .button{
        margin-top: 1%;
        margin-left: 20%;
    }
</style>